import { createSelector } from 'reselect';
import prop from 'ramda/src/prop';

const getTerritoriesRoot = (state) => state.territories;

export const getTerritoryPresetsSelector = createSelector(getTerritoriesRoot, prop('presets'));
